import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import { LANGUAGE_CONFIG } from '../i18n/languageConfig';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const currentLang = LANGUAGE_CONFIG.find((l) => l.code === i18n.language) ?? LANGUAGE_CONFIG[0];

  return (
    <>
      <IconButton
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
        aria-label="Change language"
      >
        <ReactCountryFlag
          countryCode={currentLang.countryCode}
          svg
          style={{ width: '1.4em', height: '1.4em' }}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{ paper: { sx: { maxHeight: 400 } } }}
      >
        {LANGUAGE_CONFIG.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === i18n.language}
            onClick={() => {
              i18n.changeLanguage(lang.code);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <ReactCountryFlag
                countryCode={lang.countryCode}
                svg
                style={{ width: '1.4em', height: '1.4em' }}
              />
            </ListItemIcon>
            <ListItemText>{lang.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
